export const GOOGLE_CLOUD_BUCKET_NAME = process.env.NEXT_PUBLIC_GOOGLE_CLOUD_BUCKET_NAME
export const LAMBDA_URL = process.env.NEXT_PUBLIC_LAMBDA_URL
export const MIDGARD_URL = process.env.NEXT_PUBLIC_MIDGARD_URL
export const PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL
